import React from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { Warning as ExpiredIcon, Refresh as RenewIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

const ExpiredSchools = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <ExpiredIcon sx={{ fontSize: 40, color: "error.main" }} />
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Expired Schools
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Schools with expired subscriptions - Renewal needed
            </Typography>
          </Box>
        </Box>
        <Card sx={{ mb: 3, bgcolor: "error.light", color: "error.contrastText" }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Urgent Renewal Required
                </Typography>
                <Typography variant="body2">
                  Contact expired schools immediately to renew subscriptions and prevent churn.
                </Typography>
              </Box>
              <Button variant="contained" sx={{ bgcolor: "white", color: "error.main", "&:hover": { bgcolor: "grey.100" } }} startIcon={<RenewIcon />}>
                Start Renewal Process
              </Button>
            </Box>
          </CardContent>
        </Card>
        <Typography variant="body1" sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
          Expired schools list - Filtered view of Schools component
        </Typography>
      </motion.div>
    </Box>
  );
};

export default ExpiredSchools;

